module.exports = __webpack_public_path__ + "img/mega-man.6f523c66.png";